import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { PresetSchema } from "./presets";

export enum LearnedPresetKind {
  CARRIER_SERVICE_LEVEL = "carrier-service-level",
  PARCEL = "parcel",
  WEIGHT = "weight",
}

const LearnedPresetOutputSchema = PresetSchema.omit({
  _id: true,
  name: true,
  hotkey: true,
});
export type LearnedPresetOutput = z.infer<typeof LearnedPresetOutputSchema>;

export const LearnedPresetSchema = z.object({
  kind: createEnum(LearnedPresetKind, { enumName: "LearnedPresetKind" }),
  preset: LearnedPresetOutputSchema,
  key: z.string(),
  learnedFrom: zExt.objectId(),
});
export type LearnedPreset = z.infer<typeof LearnedPresetSchema>;

export const LearnedPresetDocumentSchema = z.object({
  _id: zExt.objectId(),
  preset: LearnedPresetSchema,
  team: zExt.objectId(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export type LearnedPresetDocument = z.infer<typeof LearnedPresetDocumentSchema>;
